import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'
import { isEmpty } from 'ramda'

import DatePicker from '../../packages/kiti/components/form/date/DatePicker'
import { hasValue } from '../../utils/helpers/value'

const DateFilter = ({ field, recommendedOptions, ...props }) => {
  const rawValue = useFilterValue(field, [])
  const [localValue, setLocalValue] = React.useState(!rawValue || isEmpty(rawValue) ? undefined : rawValue)

  const handleChange = useChangeFilterValue()
  const hasFilter = hasValue(localValue)

  React.useEffect(() => {
    setLocalValue(!rawValue || isEmpty(rawValue) ? undefined : rawValue)
  }, [rawValue])

  const handleFilterChange = newValue => {
    setLocalValue(newValue)

    if (!newValue || isEmpty(newValue)) {
      handleChange(field)(undefined)
    } else {
      handleChange(field)(newValue)
    }
  }

  return (
    <DatePicker
      value={localValue}
      onChange={handleFilterChange}
      useRange
      isSelected={hasFilter}
      recommendedOptions={recommendedOptions}
      {...props}
    />
  )
}

export default DateFilter
